import { Component, OnInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { Vraag, Antwoord, SliderParameters } from '@models/claims';
import { VraagboomNumberResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { SliderHelper } from '@services/lib/helpers/slider-helper';

@Component({
  selector: 'app-slider-single',
  templateUrl: './slider-single.component.html',
  styleUrls: ['./slider-single.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SliderSingleComponent extends BaseVraagControlDirective<VraagboomNumberResultaat> implements OnInit, OnChanges {
  resultaat: VraagboomNumberResultaat = new VraagboomNumberResultaat();

  value: number;
  sliderParameters: SliderParameters;

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this.sliderParameters = SliderHelper.getSliderParameters(this.vraag.controlParameters);

    if (this.antwoordResultaat != null && this.antwoordResultaat.vraag.id === this.vraag.id && this.antwoordResultaat.resultaat != null) {
      this.resultaat = this.antwoordResultaat.resultaat;
    }
    else{
      this.resultaat.value = SliderHelper.getDefaultValue(this.sliderParameters).toString();
    }

    this.value = +this.resultaat.value;
  }

  initialize(changes: SimpleChanges): void { }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomNumberResultaat): boolean {
      return true;
  }

  sliderValueChanged(value: number) {
    this.resultaat.value = value.toString();

    this.setAntwoord(this.findAnswerWithValue(value), this.resultaat);
  }

  findAnswerWithValue(value: number): Antwoord[] {
    let antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden = this.vraag.antwoorden;
    }
    antwoorden = antwoorden.filter(answer=> this.filterAnswersByValue(answer, value));
    return antwoorden;
  }

  filterAnswersByValue(answer: Antwoord, value: number): boolean {
      let titel = answer.titel.replace('{', '').replace('}', '');
      let titelArray = titel.split(':');
      let range = titelArray[1].split(',');
      let isInRange = value >= +range[0] && value <= +range[1];
      return isInRange;
  }

  geefMeetid(): string{
    return `ipoclick-slider-${this._dataService.getMeetidPazaProces()}-${MetenMapper.format(this.vraag.titel)}`;
  }
}
